export enum EActionTypes {
  Request = 'realtorInfo/request',
  Success = 'realtorInfo/success',
  Failure = 'realtorInfo/failure',
}
